// =========================================================================
// Catálogo de enfermedades declarables en la valoración inicial
//
// Fuente única: la usan el formulario de onboarding, la revisión humana y
// cualquier pantalla que tenga que traducir un identificador a su nombre.
//
// Todo lo de aquí es DECLARACIÓN VOLUNTARIA. Son datos de salud —categoría
// especial del artículo 9 del RGPD— y solo se recogen bajo el consentimiento
// `health_data_processing`, que ya es obligatorio para operar la app.
//
// Sirven para perfilar y para decidir si la persona necesita valoración
// humana antes de entrar al programa. NO desplazan ningún objetivo por sí
// solos: ver `objetivos.ts`.
// =========================================================================

export interface Comorbilidad {
  id: string;
  etiqueta: string;
}

/** Las que se marcan con un toque. El orden es el del formulario. */
export const COMORBILIDADES: Comorbilidad[] = [
  { id: 'hta', etiqueta: 'Hipertensión arterial' },
  { id: 'dm2', etiqueta: 'Diabetes tipo 2' },
  { id: 'hipercolesterolemia', etiqueta: 'Colesterol alto' },
  { id: 'hipotiroidismo', etiqueta: 'Hipotiroidismo' },
  { id: 'tca', etiqueta: 'Trastorno de la conducta alimentaria' },
  { id: 'salud-mental', etiqueta: 'Enfermedad mental' },
  { id: 'cirugia-bariatrica', etiqueta: 'Cirugía bariátrica previa' },
  { id: 'menopausia', etiqueta: 'Menopausia' },
];

/** Prefijo de las respuestas de texto libre, para distinguirlas del catálogo. */
export const PREFIJO_OTRA = 'otra:';

export function etiquetaDe(id: string): string {
  if (id.startsWith(PREFIJO_OTRA)) return id.slice(PREFIJO_OTRA.length).trim();
  return COMORBILIDADES.find((c) => c.id === id)?.etiqueta ?? id;
}

/**
 * Convierte el texto libre en identificadores. Descarta lo vacío: una cadena
 * en blanco contaría como patología y mandaría a revisión humana a quien solo
 * tocó el campo sin escribir nada.
 */
export function otrasDesdeTexto(texto: string): string[] {
  return texto
    .split(',')
    .map((t) => t.trim())
    .filter((t) => t.length > 0)
    .map((t) => `${PREFIJO_OTRA}${t}`);
}
